import {
  createContext,
  useContext,
  useMemo,
  useState,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
} from "react";
import type { CalculatorQuoteDraft } from "./types";

interface QuoteDraftContextValue {
  draft: CalculatorQuoteDraft | null;
  setDraft: Dispatch<SetStateAction<CalculatorQuoteDraft | null>>;
}

const QuoteDraftContext = createContext<QuoteDraftContextValue | null>(null);

export function QuoteDraftProvider({ children }: { children: ReactNode }) {
  const [draft, setDraft] = useState<CalculatorQuoteDraft | null>(null);
  const value = useMemo(() => ({ draft, setDraft }), [draft]);
  return (
    <QuoteDraftContext.Provider value={value}>
      {children}
    </QuoteDraftContext.Provider>
  );
}

export function useQuoteDraft(): QuoteDraftContextValue {
  const value = useContext(QuoteDraftContext);
  if (!value) {
    throw new Error("useQuoteDraft debe usarse dentro de QuoteDraftProvider.");
  }
  return value;
}
